<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="12">
          <div class="page-title">職員列表</div>
        </el-col>
        <el-col style="text-align: right;">
          <el-button type="info" @click.native="onAddButton"
            >新增職員</el-button
          >
        </el-col>
      </el-row>
      <div class="page-content">
        <div class="page-box">
          <div class="page-content-row">
            <div>
              <div class="search-text">職員帳號</div>
              <el-input
                v-model="formLabelAlign.userNoLike"
                placeholder=""
              ></el-input>
            </div>
            <div>
              <div class="search-text">姓名</div>
              <el-input
                v-model="formLabelAlign.nameLike"
                placeholder=""
              ></el-input>
            </div>
            <div>
              <div class="search-text">分校</div>
              <el-select
                v-model="formLabelAlign.branchSchoolId"
                placeholder="請選擇分校"
              >
                <el-option
                  v-for="(item, index) in sortBranchesList"
                  :key="index"
                  :label="item.abbreviation"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">權限</div>
              <el-select v-model="formLabelAlign.roleId" placeholder="請選擇權限">
                <el-option
                  v-for="(item, index) in $store.getters.roles.filter((v) => {
                    return v.name !== 'Parent' && v.name !== 'Student';
                  })"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">電郵</div>
              <el-input
                v-model="formLabelAlign.emailLike"
                placeholder=""
              ></el-input>
            </div>
            <div>
              <div class="search-text">電話</div>
              <el-input
                v-model="formLabelAlign.phoneLike"
                placeholder=""
              ></el-input>
            </div>
            <div>
              <el-button type="info" @click="onSearch" class="button-el-el"
                >搜尋</el-button
              >
            </div>
            <div>
              <el-button type="success" @click="onReset" class="button-el-el"
                >清除篩選</el-button
              >
            </div>
          </div>
        </div>
        <el-table @sort-change="handleSortChange" :data="tableData">
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column
            prop="userNo"
            label="職員帳號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="branchSchoolId"
            label="分校"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.branchSchool">{{
                row.branchSchool.abbreviation
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="roleId"
            label="權限"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span>{{ row.roleId | roleId }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="email"
            label="電郵"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.email">{{ row.email }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="電話"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="medium" @click="onEditButton(row.id)"
                >編輯</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDeleteButton(row.id)"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formLabelAlign._page"
      :limit.sync="formLabelAlign._limit"
      @pagination="getUsers"
    />
    <deleteDialog
      titleCh="您確定要刪除此職員嗎？"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="confirmFunction"
      @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getUsers, deleteUser } from "@/api/users";
import deleteDialog from "@/components/deleteDialog";
export default {
  components: { deleteDialog, Pagination },
  data() {
    return {
      total: 0,
      staffId: null,
      formLabelAlign: {
        type: 0,
        userNoLike: null,
        nameLike: null,
        emailLike: null,
        roleId: null,
        phoneLike: null,
        branchSchoolId: null,
        gender: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      centerDialogVisible: false,
      tableData: [],
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getUsers();
    },
    onSearch() {
      this.getUsers();
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
         this.formLabelAlign[key] = null;
         if(key === '_page'){
            this.formLabelAlign[key] = 1
         }
         if(key === '_limit'){
            this.formLabelAlign[key] = 50
         }
      })
      this.getUsers();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
      this.deleteUser();
    },
    onDeleteButton(id) {
      this.staffId = id;
      this.centerDialogVisible = true;
    },
    onEditButton(id) {
      let path = `/staff/${id}/edit`
      this.resolveRouter(path)
    },
    onAddButton() {
      let path = `/staff/add`
      this.resolveRouter(path)
    },
    getUsers() {
      let listQuery = {
        type: 0,
        userNoLike: this.formLabelAlign.userNoLike,
        nameLike: this.formLabelAlign.nameLike,
        emailLike: this.formLabelAlign.emailLike,
        phoneLike: this.formLabelAlign.phoneLike,
        roleId: this.formLabelAlign.roleId,
        gender: this.formLabelAlign.gender,
        branchSchoolId: this.formLabelAlign.branchSchoolId,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getUsers(listQuery).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    deleteUser() {
      deleteUser(this.staffId)
        .then(() => {
          this.getUsers();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  background-color: #fff;
}
.page-from {
  padding: 20px;
}
.page {
  .layout {
    width: 100%;
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.button-el-el {
  margin-top: 20px;
}
.page-box{
  width: 100%;
  overflow-x: auto;
}
.page-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-content-row>div{
  min-width: 170px;
}
</style>